export default "__VITE_ASSET__D$sPs6TK__"